import { Action } from "./action";
import { Chemical } from "./chemical";
import { Equipment } from "./equipment";

export class ProcessStep{
    step: string = "";
    startPUID: string = "";
    startTimeStamp!: Date;
    endTimeStamp!: Date;
    endPUID: string = "";
    liquidHandler: string = "";
    startEquipments: Array<Equipment> = [];
    endLiquidHandler: string = "";
    endEquipments: Array<Equipment> = [];
    action: Array<Action> = [];
    chemicals: Array<Chemical> = [];
    actionMap!: Map<string, Action>;
    status?: string;
}